import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetOppsByAgent = function () {
    return useApiCall(function (signal, agentName) { return api.salesforce.apiSalesforceGetOpportunitiesByAgentGet(agentName, { signal: signal }); }, null, true, [], { success: 'Fetched my opportunities', error: 'Failed to fetch my opportunities' });
};
